import { Component, input } from '@angular/core';

@Component({
    selector: 'message-loader',
    templateUrl: './message-loader.component.html',
    standalone: false
})
export class MessageLoaderComponent {
    public avatarBotOrLive = input<string>();
    public showAvatar = input<boolean>();
}
